export enum OrderType {
  NOT_AVAILABLE = 'N/A',
  AUTOMATIC = 'Automatic',
  REMITTANCE = 'Remittance',
}
